/**
 * Provide navigation list based on a set of fields
 */

import { useStaticQuery, graphql } from "gatsby"
import { normalizePath } from "~utils/path"

export const CHANGELOG_TAG_OVERRIDES = {
  ...require("../../content/changelog-tag-overrides.json"),
  ...require("../../../.source-cache/.ngwaf-changelog/friendly-names.json"),
}

const tagMapFn =
  ({ uppercase } = { uppercase: true }) =>
  (node) => {
    const title = CHANGELOG_TAG_OVERRIDES[node.toLowerCase()] ?? node
    return {
      title: uppercase ? title.toUpperCase() : title,
      path: normalizePath(`/reference/changes/${node}`),
    }
  }

const postMapFn = (node) => {
  return { title: node.pageContext.title, path: node.path }
}

const types = {
  affectedSystems: {
    title: "Changes to",
    mapFn: tagMapFn({ uppercase: false }),
  },
  changeLabels: {
    title: "Labels",
    mapFn: tagMapFn(),
  },
  recentChanges: {
    title: "Recent changes",
    mapFn: postMapFn,
  },
}

export default (type, activePath) => {
  const gql = graphql`
    query {
      affectedSystems: allSitePage(filter: { path: { glob: "/reference/changes/*/*/*" } }) {
        items: distinct(field: pageContext___affectedSystems)
      }
      changeLabels: allSitePage(filter: { path: { glob: "/reference/changes/*/*/*" } }) {
        items: distinct(field: pageContext___labels)
      }
      recentChanges: allSitePage(
        filter: { path: { glob: "/reference/changes/*/*/*" }, pageContext: { paginate: { eq: null } } }
        sort: { order: DESC, fields: [pageContext___changeDate, pageContext___title] }
        limit: 5
      ) {
        items: nodes {
          path
          pageContext {
            title
          }
        }
      }
    }
  `

  const items = useStaticQuery(gql)[type].items
  const ngwafItem = {
    title: "Next-Gen WAF",
    path: "/reference/changes#ngwaf",
    isActive: activePath.includes("ngwaf"),
    children: [],
  }
  const links = items
    .map(types[type].mapFn)
    .filter((item) => !!item)
    .map((item) => ({ ...item, isActive: item.path === normalizePath(activePath) }))
    .map((item) => {
      if (item.path.startsWith("/reference/changes/ngwaf")) {
        ngwafItem.children.push(item)
        return null
      } else {
        return item
      }
    })
    .filter((item) => !!item)

  if (type === "affectedSystems") links.push(ngwafItem)

  return {
    title: types[type].title,
    isActive: true,
    children: links,
  }
}
